import React from "react";
import "./Loader.css"; 

const Loader = () => {
  return (
    <>
    {/* <div className="wrapper">
   <span className="dot"></span>
   <span className="dot"></span>
   <span className="dot"></span>
   <span className="dot"></span>
   <span style={{color:"#008d96",fontSize:"2rem"}}>Loading...</span>
   
  </div> */}
<div className="load-container">
<div className="loader">
  <div className="loader__bar"></div>
  <div className="loader__bar"></div>
  <div className="loader__bar"></div>
  <div className="loader__bar"></div>
  <div className="loader__bar"></div>
  <div className="loader__ball"></div>
</div>
</div>
  </>
  );
};

export default Loader;
